import React, { useState, useContext, forwardRef, useImperativeHandle } from 'react';
import { RadioGroup, Radio, FormControl, FormLabel, FormControlLabel } from '@material-ui/core';
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext.js';

const PrintDialog = forwardRef((props, ref) => {
    const { theme } = useContext(Theme);
    const { close } = props;
    const [fileFormat, setFileFormat] = useState("PDF");
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    const saveExportFormat = () => {
        close();
        props.processBulkExport(fileFormat);
    };

    useImperativeHandle(ref, () => {
        return {
            save: saveExportFormat,
        };
    });

    return (
        <div>
            <FormControl component="fieldset">
                <FormLabel component="legend" style={{ color: currentTheme.text, fontWeight: 'bold', textTransform: 'none' }}>Select the bulk export file format (PDF or ZIP)</FormLabel>
                <RadioGroup
                    aria-label="position"
                    name="position"
                    value={fileFormat || null}
                    onChange={(e) => { setFileFormat(e.target.value); }}
                >
                    <FormControlLabel
                        value="PDF"
                        control={<Radio style={{ color: currentTheme.secondary }} />}
                        label="Single PDF (Generates one combined PDF)"
                        labelPlacement="end"
                        style={{ color: currentTheme.text }}
                    />
                    <FormControlLabel
                        value="ZIP"
                        control={<Radio style={{ color: currentTheme.secondary }} />}
                        label="Individual PDFs (Generates a ZIP file where each observation log is a separate PDF file)"
                        labelPlacement="end"
                        style={{ color: currentTheme.text }}
                    />
                </RadioGroup>
            </FormControl>
        </div>
    );
});

export default PrintDialog;
